import type { ReactNode } from 'react';
import { CursorArrowIcon, HandIcon } from '@radix-ui/react-icons';
import { Button, Tooltip } from '@radix-ui/themes';
import { useTranslation, type MessageKey } from '../../../i18n';
import { useEditorStore } from '../../../stores/editorStore';

export function SelectionTools() {
  const { t } = useTranslation();
  const { currentTool, setTool } = useEditorStore();

  const selectionTools: { id: 'select' | 'pan'; icon: ReactNode; titleKey: MessageKey }[] = [
    { id: 'select', icon: <CursorArrowIcon />, titleKey: 'toolbar.tools.select' },
    { id: 'pan', icon: <HandIcon />, titleKey: 'toolbar.tools.pan' },
  ];

  return (
    <div className="selection-tools">
      {selectionTools.map((tool) => (
        <Tooltip key={tool.id} content={t(tool.titleKey)}>
          <Button
            variant="soft"
            radius="none"
            size="3"
            onClick={() => setTool(tool.id)}
            className={currentTool === tool.id ? 'active' : ''}
          >
            {tool.icon}
          </Button>
        </Tooltip>
      ))}
    </div>
  );
}
